import { QueryClient } from '@tanstack/react-query';
import { ApiClientError } from './api';
import { clearToken } from './token';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiClientError && error.status === 401) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

// Global 401 handler — any failed query/mutation with 401 clears the token.
// The router's beforeLoad guard will then redirect to /login on next navigation.
queryClient.getQueryCache().subscribe((event) => {
  const err = event.query.state.error;
  if (err instanceof ApiClientError && err.status === 401) {
    clearToken();
  }
});
queryClient.getMutationCache().subscribe((event) => {
  if (event.type === 'updated' && event.mutation.state.error) {
    const err = event.mutation.state.error;
    if (err instanceof ApiClientError && err.status === 401) {
      clearToken();
    }
  }
});
